export default __webpack_public_path__ + "static/media/icon-location.7bf45c7b.svg";